import axios from 'axios'
import Qs from 'qs'

export default {
  config () {
    return {
      mode: 'no-cors',
      responseType: 'json',
      headers: {
        'Accept': 'application/json,text/html,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
        'Content-Type': 'application/json'
      },
      'paramsSerializer': function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  },
  request (method, headers, endpoint, data, params) {
    headers = Object.assign(this.config().headers, headers)
    return axios(
      Object.assign(this.config(),
        {
          method: method,
          headers: headers,
          url: endpoint,
          data: data,
          params: params
        }
      ))
  },
  download (method, headers, endpoint, data, params) {
    headers = Object.assign(this.config().headers, headers)
    return axios(
      Object.assign(this.config(),
        {
          method: method,
          headers: headers,
          url: endpoint,
          data: data,
          params: params,
          responseType: 'arraybuffer'
        }
      )).then(response => {
      let blob = new Blob([response.data], {type: 'application/xlsx'})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.headers['x-suggested-filename']
      link.click()
      return 'finished'
    }).catch(error => {
      var dec = String.fromCharCode.apply(null, new Uint8Array(error.response.data))
      var errorMessage = JSON.parse(dec)
      error.response.data = errorMessage
      throw error
    })
  },
  multipartRequest (method, headers, endpoint, data, params) {
    headers = Object.assign(this.config().headers, headers)
    headers['Content-Type'] = 'multipart/form-data'
    return axios(
      Object.assign(this.config(),
        {
          method: method,
          headers: headers,
          url: endpoint,
          data: data,
          params: params
        }
      ))
  },
  downloadFile (method, headers, endpoint, data, params) {
    headers = Object.assign(this.config().headers, headers)
    return axios(
      Object.assign(this.config(),
        {
          method: method,
          headers: headers,
          url: endpoint,
          data: data,
          params: params,
          responseType: 'arraybuffer'
        }
      )
    ).then(response => {
      let blob = new Blob([response.data], {type: 'application'})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.headers['x-suggested-filename']
      link.click()
      return 'finished'
    }).catch(error => {
      var dec = String.fromCharCode.apply(null, new Uint8Array(error.response.data))
      var errorMessage = JSON.parse(dec)
      error.response.data = errorMessage
      throw error
    })
  },
  contact (data) {
    return axios(
      Object.assign(this.config(),
        {
          method: 'post',
          url: 'https://products-backend.kaleidotechnology.com/api/send-mail',
          data: data
        }
      ))
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js